import { render, staticRenderFns } from "./EducationFormNew.vue?vue&type=template&id=0c4d4b12"
import script from "./EducationFormNew.vue?vue&type=script&lang=ts"
export * from "./EducationFormNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4d4b12')) {
      api.createRecord('0c4d4b12', component.options)
    } else {
      api.reload('0c4d4b12', component.options)
    }
    module.hot.accept("./EducationFormNew.vue?vue&type=template&id=0c4d4b12", function () {
      api.rerender('0c4d4b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/EducationFormNew.vue"
export default component.exports